import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PapelTimbrado from "../pages/papel-timbrado/page";
import Folder from "../pages/folder/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/papel-timbrado",
    element: <PapelTimbrado />,
  },
  {
    path: "/folder",
    element: <Folder />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
